<template>
  <div class="dating-detail-page">
    <van-nav-bar fixed placeholder class="page-nav" :border="false">
      <template #left>
        <img
          class="back-icon"
          src="https://m.sincereloves.online/icon/download.png"
          alt="back"
          @click="onClickLeft"
        >
      </template>
      <template #title>
        <span class="page-title">{{ $t('ui.detail.title') }}</span>
      </template>
      <template #right>
        <van-icon name="home-o" class="home-icon" @click="$router.push('/Home')" />
      </template>
    </van-nav-bar>

    <div class="page-content">
      <section class="video-section">
        <template v-if="displayVideoUrl">
          <video
            :src="displayVideoUrl"
            controls
            controlslist="nodownload noremoteplayback"
            preload="metadata"
            class="dating-video"
            poster="https://m.sincereloves.online/logo.png"
          >
            {{ $t('ui.detail.video_unsupported') }}
          </video>
        </template>
        <div v-else class="video-placeholder">
          <img class="placeholder-logo" src="https://m.sincereloves.online/logo.png" alt="logo">
          <span>{{ $t('ui.detail.no_video') }}</span>
        </div>

      </section>

      <section class="notice-section">
        <div class="notice-container">
          <img src="https://m.sincereloves.online/icon/notice.png" alt="notice" class="notice-icon">
          <div class="notice-content">
            <div class="marquee-wrapper">
              <div class="marquee-track">
                <span class="marquee-item">{{ noticeText }}</span>
              </div>
            </div>
          </div>
          <div class="notice-label">{{ $t('ui.detail.notice') }}</div>
        </div>
      </section>

      <section class="title-section">
        <h1 class="dating-title">{{ $t('ui.common.id_prefix') }}{{ displayId }}</h1>
      </section>

      <section class="score-section">
        <div class="info-box score-box">
          <div class="score-left">
            <div class="score-label">{{ $t('ui.detail.score') }}</div>
            <div class="score-value">{{ displayScore }}</div>
            <div class="beauty-label">{{ $t('ui.detail.beauty_value') }}</div>
          </div>

          <div class="contact-right">
            <div class="contact-item">
              {{ $t('ui.detail.specific_address') }}<br>
              {{ displayAddress }}
            </div>
            <div class="contact-item">
              {{ $t('ui.detail.contact_info') }}<br>
              {{ displayContactInfo }}
            </div>
          </div>
        </div>
      </section>

      <section class="details-section">
        <div class="info-box details-box">
          <div class="detail-item">
            <img src="https://m.sincereloves.online/icon/ico_res02.png" alt="stage" class="detail-icon">
            <span>{{ $t('ui.detail.stage_name') }}{{ displayStageName }}</span>
          </div>
          <div class="detail-item">
            <img src="https://m.sincereloves.online/icon/ico_res03.png" alt="location" class="detail-icon">
            <span>{{ $t('ui.detail.location') }}{{ displayLocation }}</span>
          </div>
          <div class="detail-item intro-item">
            <img src="https://m.sincereloves.online/icon/ico_res04.png" alt="intro" class="detail-icon">
            <span>{{ $t('ui.detail.introduction') }}{{ displayIntro }}</span>
          </div>
        </div>
      </section>

      <section class="content-section">
        <div class="rich-content">
          <img
            v-for="(item, index) in normalizedImages"
            :key="`${item}-${index}`"
            :src="item"
            :alt="`${displayStageName}-${index}`"
            class="content-image"
          >
        </div>
      </section>

      <div class="action-wrap">
        <button class="meet-btn" type="button" @click="handleMeetNow">
          {{ $t('ui.detail.meet_now') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      scrollbarStyleId: 'detail-scrollbar-style',
      systemNotice: ''
    };
  },
  computed: {
    displayId() {
      return this.data.id || this.$route.query.id || '--';
    },
    displayStageName() {
      return this.data.xuanfei_name || `VIP${this.displayId}`;
    },
    displayLocation() {
      return this.localizedFlag || this.data.address || this.$t('ui.common.default_location');
    },
    displayScore() {
      const numeric = Number(this.data.number || this.data.chakan || this.data.dianzan || 9.9);
      return Math.min(10, Math.max(9.6, numeric)).toFixed(1);
    },
    displayIntro() {
      return this.data.jianjie || this.noticeText || this.data.vo_title || this.$t('ui.detail.no_intro');
    },
    displayAddress() {
      return this.$t('ui.detail.hidden_contact');
    },
    displayContactInfo() {
      return this.$t('ui.detail.hidden_contact');
    },
    displayVideoUrl() {
      return this.normalizeAssetUrl(this.data.pvideo);
    },
    normalizedImages() {
      const images = Array.isArray(this.data.img_url)
        ? this.data.img_url
        : typeof this.data.img_url === 'string' && this.data.img_url
          ? this.data.img_url.split(',').filter(Boolean)
          : [];

      return images
        .map((item) => this.normalizeAssetUrl(item))
        .filter(Boolean);
    },
    localizedFlag() {
      const rawFlag = typeof this.data.flag === 'string' ? this.data.flag : '';
      if (!rawFlag) {
        return '';
      }

      const lang = localStorage.getItem('lang') || 'zh';
      const parts = rawFlag.split('|');
      if (lang === 'en') {
        return parts[1] || parts[0] || '';
      }
      if (lang === 'ja') {
        return parts[2] || parts[0] || '';
      }
      if (lang === 'kr') {
        return parts[3] || parts[0] || '';
      }

      return parts[0] || '';
    },
    noticeText() {
      const summary = [
        this.data.age ? `${this.$t('ui.detail.age')}${this.data.age}` : '',
        this.data.bust ? `${this.$t('ui.detail.bust')}${this.data.bust}` : '',
        this.data.hight ? `${this.$t('ui.detail.height')}${this.data.hight}` : '',
        this.data.weight ? `${this.$t('ui.detail.weight')}${this.data.weight}` : ''
      ].filter(Boolean).join(' ');

      return this.systemNotice || summary || this.data.vo_title || this.data.jianjie || this.$t('ui.detail.default_notice');
    }
  },
  methods: {
    normalizeAssetUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }

      const origin = 'https://admin699.ytb789.com';

      if (/^https?:\/\/127\.0\.0\.1\//.test(url)) {
        return url.replace(/^https?:\/\/127\.0\.0\.1\//, `${origin}/`);
      }

      if (/^https?:\/\/localhost:8081\//.test(url)) {
        return url.replace(/^https?:\/\/localhost:8081\//, `${origin}/`);
      }

      if (url.startsWith('/')) {
        return `${origin}${url}`;
      }

      return url;
    },
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id }
      }).then((res) => {
        this.data = res && res.data && typeof res.data === 'object' ? res.data : {};
      });
    },
    getSystemNotice() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then((res) => {
        const notice = res && res.data && typeof res.data.notice === 'string'
          ? res.data.notice.trim()
          : '';
        this.systemNotice = notice;
      }).catch(() => {
        this.systemNotice = '';
      });
    },
    handleMeetNow() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(this.$t('ui.detail.toast_activate'));
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    hideRootScrollbar() {
      if (typeof document === 'undefined') {
        return;
      }

      const root = document.documentElement;
      const body = document.body;

      root.style.setProperty('scrollbar-width', 'none');
      body.style.setProperty('scrollbar-width', 'none');
      root.style.setProperty('-ms-overflow-style', 'none');
      body.style.setProperty('-ms-overflow-style', 'none');

      if (!document.getElementById(this.scrollbarStyleId)) {
        const style = document.createElement('style');
        style.id = this.scrollbarStyleId;
        style.textContent = `
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}
        `;
        document.head.appendChild(style);
      }
    },
    restoreRootScrollbar() {
      if (typeof document === 'undefined') {
        return;
      }

      const root = document.documentElement;
      const body = document.body;
      const style = document.getElementById(this.scrollbarStyleId);

      root.style.removeProperty('scrollbar-width');
      body.style.removeProperty('scrollbar-width');
      root.style.removeProperty('-ms-overflow-style');
      body.style.removeProperty('-ms-overflow-style');

      if (style && style.parentNode) {
        style.parentNode.removeChild(style);
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.hideRootScrollbar();
  },
  beforeDestroy() {
    this.restoreRootScrollbar();
  },
  created() {
    this.getxuanfeidata();
    this.getSystemNotice();
  }
};
</script>

<style lang="less" scoped>
.dating-detail-page {
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.page-nav {
  min-height: 98px;
  background: #1c1c1e;
}

::v-deep .page-nav .van-nav-bar {
  background: #1c1c1e;
  box-shadow: none;
}

::v-deep .page-nav .van-nav-bar__content {
  height: 88px;
}

::v-deep .page-nav .van-nav-bar__left,
::v-deep .page-nav .van-nav-bar__right {
  padding: 0 18px;
}

.back-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.page-title {
  color: #e6b98a;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.home-icon {
  color: #e6b98a;
  font-size: 38px;
}

.page-content {
  padding-bottom: 28px;
}

.video-section {
  margin-bottom: 16px;
  background: #101010;
}

.dating-video,
.video-placeholder {
  display: block;
  width: 100%;
  min-height: 240px;
  max-height: 72vh;
  background: #101010;
}

.dating-video {
  object-fit: contain;
}

.video-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c8a47f;
  gap: 10px;
}

.placeholder-logo {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.notice-section,
.title-section,
.score-section,
.details-section,
.content-section,
.action-wrap {
  padding: 0 8px;
}

.notice-container {
  display: flex;
  align-items: center;
  padding: 16px 18px;
  border: 2px solid #766350;
  border-radius: 14px;
  background: linear-gradient(90deg, #212121, #313131);
}

.notice-icon {
  width: 30px;
  height: 30px;
  margin-right: 12px;
  object-fit: contain;
}

.notice-content {
  flex: 1;
  overflow: hidden;
}

.marquee-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.marquee-track {
  display: inline-block;
  align-items: center;
  min-width: 100%;
  padding-left: 140%;
  animation: notice-scroll 120s linear infinite;
  will-change: transform;
}

.marquee-item {
  display: inline-block;
  color: #f3c7a2;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
}

.notice-label {
  color: #f3c7a2;
  font-size: 22px;
  font-weight: 700;
}

@keyframes notice-scroll {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
}

.title-section {
  margin: 14px 0;
  text-align: left;
}

.dating-title {
  margin: 0;
  color: #fff;
  font-size: 34px;
  font-weight: 800;
}

.info-box {
  border: 1px solid #766350;
  background: linear-gradient(90deg, #212121, #313131);
}

.score-box {
  display: flex;
  padding: 24px 10px;
  border-radius: 5px;
}

.score-left {
  width: 30%;
  padding-right: 14px;
  text-align: center;
  border-right: 1px solid #766350;
}

.score-label,
.beauty-label {
  color: #fff;
  font-size: 22px;
  font-weight: 700;
}

.score-value {
  margin: 8px 0;
  color: #e6b98a;
  font-size: 44px;
  font-weight: 800;
}

.contact-right {
  width: 70%;
  padding-left: 14px;
}

.contact-item {
  color: #f3c7a2;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.65;
}

.contact-item + .contact-item {
  margin-top: 16px;
}

.details-section {
  margin-top: 14px;
}

.details-box {
  padding: 16px 12px;
  border-radius: 2px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  color: #f3c7a2;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.7;
}

.detail-item + .detail-item {
  margin-top: 14px;
}

.detail-icon {
  width: 24px;
  height: 24px;
  margin: 5px 10px 0 0;
  object-fit: contain;
  flex-shrink: 0;
}

.intro-item span {
  word-break: break-word;
}

.content-section {
  margin-top: 14px;
}

.rich-content {
  color: #bd9777;
}

.content-image {
  display: block;
  width: 100%;
  margin-bottom: 12px;
}

.content-image:last-child {
  margin-bottom: 0;
}

.action-wrap {
  margin-top: 20px;
}

.meet-btn {
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(to right, #fde3ca, #e7b486);
  color: #68302c;
  font-size: 18px;
  font-weight: 700;
}
</style>
